document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    // Lazy Loading Images
    lazyloadImages = document.querySelectorAll("source, .lazy");
    var imageObserver = new IntersectionObserver(function (entries, observer) {

      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          if (image.dataset && image.dataset.src) {
            image.src = image.dataset.src;
            image.classList.add('animate');
          }
          if (image.dataset && image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
            image.classList.add('animate');
          }
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    }, {
      rootMargin: "0px 0px 800px 0px"
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.POLL_INTERVAL = 700;
      imageObserver.observe(image);
    });
  }
});
